















































































































































































































import Component from 'vue-class-component';
import OfficesCriteriaComponent from '@/containers/account/offices/criteria/offices-criteria.vue';
import { IOffice } from '@/entities/offices/office.interface';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import { ISort } from '@/entities/sort.interface';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';
import officesApi from '@/api/offices.api';
import * as types from '@/store/types';
import { IConfirm } from '@/entities/confirm.interface';
import { IUpdateStatus } from '@/entities/update-status.interface';
import { mapGetters } from 'vuex';

@Component({
    components: {
        'app-offices-criteria': OfficesCriteriaComponent
    },
    computed: mapGetters({
        superAdminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class OfficesMaster extends MasterPageCriteria {
    public items: IOffice[] = [];

    protected defaultSort: ISort = {
        field: 'officeName',
        asc: true
    };


    public activate(office: IOffice) {
        this._updateStatus([office.companyId], { active: true });
    }

    public suspend(office: IOffice) {
        this._updateStatus(
            [office.companyId],
            { active: false },
            'Are you sure to suspend office and all agents?'
        );
    }

    public show(office: IOffice) {
        this._updateStatus(
            [office.companyId],
            { hidden: false },
            'Are you sure to show office and all agents?'
        );
    }

    public hide(office: IOffice) {
        this._updateStatus(
            [office.companyId],
            { hidden: true },
            'Are you sure to hide office and all agents?'
        );
    }

    public activateSelected() {
        this._updateStatus(
            this.selected,
            { active: true },
            'Are you sure to activate selected offices and all they agents?'
        );
    }

    public suspendSelected() {
        this._updateStatus(
            this.selected,
            { active: false },
            'Are you sure to suspend selected offices and all they agents?'
        );
    }

    public list(body: ISearchBody): Promise<IPaging<IOffice>> {
        return officesApi.list(body);
    }

    private _updateStatus(
        ids: number[],
        model: IUpdateStatus,
        heading: string = 'Are you sure?'
    ) {
        let afterFn = (closeFn: () => void) => {
            officesApi
                .updateStatusBatch(ids, model)
                .then(() => {
                    this._updateItemsStatus(ids, model);
                    this.selected = [];
                    closeFn();
                })
                .catch(() => closeFn());
        };

        let payload: IConfirm = {
            heading,
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    private _updateItemsStatus(ids: number[], model: IUpdateStatus) {
        this.items = this.items.map((item) => {
            if (ids.indexOf(item.companyId) === -1) {
                return item;
            } else {
                return { ...item, ...model };
            }
        });
    }
}
